module.exports = __webpack_public_path__ + "img/feigongliyiliao.26ef0edf.png";